import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { ContactComponent } from './pages/contact/contact.component';

import { HomeComponent } from './pages/home/home.component';
import { MethodsComponent } from './pages/methods/methods.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { StochasticModellingComponent } from './pages/methods/stochastic-modelling/stochastic-modelling.component';
import { BayesianInferenceComponent } from './pages/methods/bayesian-inference/bayesian-inference.component';
import { DataVisualisationComponent } from './pages/methods/data-visualisation/data-visualisation.component';
import { PopulationModellingComponent } from './pages/methods/population-modelling/population-modelling.component';
import { ReactionDiffusionSystemsComponent } from './pages/methods/reaction-diffusion-systems/reaction-diffusion-systems.component';
import { SpatialModellingComponent } from './pages/methods/spatial-modelling/spatial-modelling.component';
import { InflusimComponent } from './pages/projects/influsim/influsim.component';
import { MenschmikrobeComponent } from './pages/projects/menschmikrobe/menschmikrobe.component';
import { Schis2hivComponent } from './pages/projects/schis2hiv/schis2hiv.component';
import { QlaivsimComponent } from './pages/projects/qlaivsim/qlaivsim.component';
import { FourfluComponent } from './pages/projects/fourflu/fourflu.component';
import { SimsthComponent } from './pages/projects/simsth/simsth.component';
import { HantaComponent } from './pages/projects/hanta/hanta.component';
import { Inetfa2Component } from './pages/projects/inetfa2/inetfa2.component';
import { NmaComponent } from './pages/projects/nma/nma.component';
import { CovidcontrolComponent } from './pages/projects/covidcontrol/covidcontrol.component';
import { CovidsimComponent } from './pages/projects/covidsim/covidsim.component';
import { KsasimComponent } from './pages/projects/ksasim/ksasim.component';
import { TommiComponent } from './pages/projects/tommi/tommi.component';
import { ImaacComponent } from './pages/projects/imaac/imaac.component';
import { AggComponent } from './pages/projects/agg/agg.component';
import { IntersimComponent } from './pages/projects/intersim/intersim.component';
import { CtempComponent } from './pages/projects/ctemp/ctemp.component';
import { FourstrepComponent } from './pages/projects/fourstrep/fourstrep.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'methods', component: MethodsComponent },
  { path: 'methods/stochastic-modelling', component: StochasticModellingComponent },
  { path: 'methods/population-modelling', component: PopulationModellingComponent },
  { path: 'methods/spatial-modelling', component: SpatialModellingComponent },
  { path: 'methods/bayesian-inference', component: BayesianInferenceComponent },
  { path: 'methods/reaction-diffusion-systems', component: ReactionDiffusionSystemsComponent },
  { path: 'methods/data-visualisation', component: DataVisualisationComponent },
  { path: 'projects', component: ProjectsComponent },
  { path: 'projects/InterSim', component: IntersimComponent},
  { path: 'projects/InfluSim', component: InflusimComponent},
  { path: 'projects/MenschMikrobe', component: MenschmikrobeComponent},
  { path: 'projects/Q-LAIV-Sim', component: QlaivsimComponent},
  { path: 'projects/Aktiv-gegen-Grippe', component: AggComponent},
  { path: 'projects/4Flu', component: FourfluComponent},
  { path: 'projects/ctemp1', component: CtempComponent},
  { path: 'projects/Schis-2-HIV', component: Schis2hivComponent},
  { path: 'projects/SIM-STH', component: SimsthComponent},
  { path: 'projects/Hanta-Prediction', component: HantaComponent},
  { path: 'projects/iNET-FA2', component: Inetfa2Component},
  { path: 'projects/Network-Meta-Analysis', component: NmaComponent},
  { path: 'projects/4Strep', component: FourstrepComponent},
  { path: 'projects/IMAAC', component: ImaacComponent},
  { path: 'projects/TOMMI', component: TommiComponent},
  { path: 'projects/CovidSIM', component: CovidsimComponent},
  { path: 'projects/CovidControl', component: CovidcontrolComponent},
  { path: 'projects/KSASIM', component: KsasimComponent},
  { path: 'profile', component: ProfileComponent },
  { path: 'contact', component: ContactComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
